export const championshipConsts = {
    TYPE: {
        ACTIVE: "ACTIVE",
        INFINITY: "INFINITY",
        ENDED: "ENDED",
        TEST: "TEST",
    },
    //sort config in frontend/src/components/championshipFullPage/rating/index.jsx
    METRIC: {
        MRR: "MRR",
        MAPE: "MAPE",
        MAE: "MAE",
        ACCURACY: "ACCURACY",
        AUC: "AUC",
        F1: "F1",
        F1_HH: "F1_HH",
        F1_MACRO: "F1_MACRO",
        WRMSE: "WRMSE",
        RMSE: "RMSE",
        RMSLE: "RMSLE",
        LOG_LOSS: "LOG_LOSS",
        LOG_LOSS_PYTH: "LOG_LOSS_PYTH",
        MNAP20_JSON: "MNAP20_JSON",
        EER: "EER",
        ROC_AUC_5C: "ROC_AUC_5C",
        HACKATHON_PYTH: "HACKATHON_PYTH",
        ROSNEFT_DICE_METRIC: "ROSNEFT_DICE_METRIC",
        AVERAGE_AUC6: "AVERAGE_AUC6",
        PROPANT: "PROPANT",
        WMAE: "WMAE",
        HIT: "HIT",
        HIT5: "HIT5",
        BERT: "BERT"

    },

    RANGING: {
        DOWN_UP: "DOWN_UP",
        TOP_DOWN: "TOP_DOWN",
    },

    DELETE_CHAMPIONSHIP: "DELETE_CHAMPIONSHIP",
    UPDATE_ALL_CHAMPIONSHIPS: " UPDATE_ALL_CHAMPIONSHIPS",
    UPDATE_CHAMP: "UPDATE_CHAMP",
    ADD_CHAMPIONSHIP_TO_STORAGE: "ADD_CHAMPIONSHIP_TO_STORAGE",
    UPDATE_CHAMPIONSHIP_INFO_IN_STORAGE: "UPDATE_CHAMPIONSHIP_INFO_IN_STORAGE",
    CHANGE_CHAMP_STATE: "CHANGE_CHAMP_STATE",
};


export const TEST_TYPE = {
    err: "#DE3D63",
    ok: "#306DE6",
    disp: "#E6A930",
};

export default championshipConsts;



// WEBPACK FOOTER //
// src/constants/championship.jsx